<div class="search-container flex items-center w-full">
  <div class="relative flex-1">
    <input
      aria-label="Search for anything"
      autocomplete="off"
      inputmode="search"
      placeholder="Search"
      type="search"
      class="w-full"
      [formControl]="searchService.searchTermFormControl"
    />
  </div>
  <div class="ml-2">
    <app-filter (filterChanged)="searchService.setFilters($event)"></app-filter>
  </div>
</div>

